import React, { useState, useEffect } from "react"

import { getParticipantProductRolesByParticipantUUID } from "@/apisParticipantPublic"
import Box from "@material-ui/core/Box"
import Divider from "@material-ui/core/Divider"
import clsx from "clsx"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import DynamicImage from "@/hooks/dynamicImage"
import Radio from "@material-ui/core/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormControl from "@material-ui/core/FormControl"
import Button from "@material-ui/core/Button"

const useStyles = makeStyles((theme) => ({
    roleWrapper: {
        marginBottom: theme.spacing(6),
    },
    titleWrapper: {
        marginBottom: theme.spacing(4),
        textAlign: "center",
    },
    roleDetailWrapper: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        justifyContent: "center",
        maxWidth: "1200px",
        marginLeft: "auto",
        marginRight: "auto",
        textAlign: "center",
    },
    roleContainer: {
        padding: theme.spacing(4),
        position: "relative",
        [theme.breakpoints.up("md")]: {
            marginBottom: "50px",
        },
    },
    roleImageWrapper: {
        width: "170px",
        height: "auto",
        position: "relative",
        margin: "0 auto",
        "& > img": {
            width: "100%",
            height: "auto",
            paddingBottom: theme.spacing(4),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(4),
        },
    },
    roleName: {
        marginBottom: theme.spacing(2),
        fontWeight: "600",
    },
    roleDescriptionWrapper: {
        padding: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: "left",
        fontSize: "90%",
        "& p": {
            marginBottom: theme.spacing(3),
        },
    },
    selectButton: {
        [theme.breakpoints.up("md")]: {
            position: "absolute",
            bottom: "30px",
            left: "50%",
            transform: "translateX(-50%)",
        },
    },
    radioLabel: {
        color: "black",
        margin: theme.spacing(4),
        flexBasis: "calc(50% - 40px)",
        boxShadow: "0 0 5px 4px rgb(222 222 222)",
        "& .MuiFormControlLabel-label": {
            height: "100%",
        },
        "&>.Mui-checked~.MuiFormControlLabel-label>$roleContainer": {
            backgroundColor: "#9cc6da",
        },
        "&>.Mui-checked~.MuiFormControlLabel-label>$roleContainer .MuiButton-root": {
            backgroundColor: "black",
            color: "#ffffff",
        },
        "&>.MuiRadio-root": {
            display: "none",
        },
        "& $roleContainer": {
            cursor: "pointer",
            height: "100%",
        },
    },
    radioGroup: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
        },
    },
    dangerouslySetInnerHTMLWrapper: {
        "&>p": {
            marginBottom: "20px",
        },
    },
    activeNone: {
        backgroundColor: "black",
        color: "#ffffff",
    },
}))

const Role = (props) => {
    const { participantUUID, participant, handleUpdateParticipant, setParticipantDetailError } = props
    const classes = useStyles()
    const [roles, setRoles] = useState([])
    const [checkedRoleId, setCheckedRoleId] = useState(null)
    const [roleLoading, setRoleLoading] = useState({
        loading: true,
        error: false,
        message: "",
    })
    const handleRoleChange = (event) => {
        setCheckedRoleId(Number(event.target.value))
        handleUpdateParticipant("roleId", Number(event.target.value))
    }
    const handleRoleButtonClick = (roleId) => {
        setCheckedRoleId(roleId)
        handleUpdateParticipant("roleId", roleId)
    }
    const noneButtonOnClick = () => {
        setCheckedRoleId(0)
        handleUpdateParticipant("roleId", 0)
    }

    useEffect(() => {
        const getRoles = async () => {
            try {
                const resultRoleData = await getParticipantProductRolesByParticipantUUID(participantUUID)
                const resultRole = resultRoleData.data.productRoles
                setRoles(resultRole)
                setRoleLoading({
                    loading: false,
                    error: false,
                    message: null,
                })
            } catch (error) {
                setRoleLoading({
                    loading: false,
                    error: true,
                    message: "error",
                })
                setParticipantDetailError({ status: true, message: "setting loading wrong", update: false })
            }
        }
        getRoles()
    }, [])

    useEffect(() => {
        const handleProjectManagerInit = () => {
            if (participant.projectManager && roles.length && roles[0].roleId === 11) {
                handleUpdateParticipant("roleId", 11)
            }
        }
        handleProjectManagerInit()
    }, [roles])

    let titleOutput
    let roleDetailOutput
    if (!participant.projectManager && roles.length === 1 && roles[0].roleId === 11) {
        titleOutput = (
            <Box>
                <Box className={classes.titleWrapper}>
                    <Typography variant="h6" component="h2">
                        <span style={{ color: "black" }}>Hi&nbsp;</span>
                        {participant.lastName ? `${participant.firstName} ${participant.lastName}` : `${participant.firstName}`}
                        <span style={{ color: "black" }}>
                            ,&nbsp;you have been selected to participate in a quick 5-minute assessment, do you agree to continue?
                        </span>
                    </Typography>
                </Box>
            </Box>
        )
        roleDetailOutput = (
            <>
                <Box>
                    <FormControl component="fieldset">
                        <RadioGroup
                            aria-label="role"
                            name="role"
                            value={checkedRoleId}
                            onChange={handleRoleChange}
                            className={classes.radioGroup}
                        >
                            <FormControlLabel value={11} control={<Radio />} label="Yes" />
                            <FormControlLabel value={0} control={<Radio />} label="No" />
                        </RadioGroup>
                    </FormControl>
                </Box>
            </>
        )
    } else if (participant.projectManager && roles.length === 1 && roles[0].roleId === 11) {
        titleOutput = (
            <Box>
                <Box>
                    <Typography variant="h6" component="h2" style={{ color: "black" }}>
                        Hi {participant.lastName ? `${participant.firstName} ${participant.lastName}` : `${participant.firstName}`},
                    </Typography>
                </Box>
            </Box>
        )
        roleDetailOutput = null
    } else {
        titleOutput = (
            <Box>
                <Box className={classes.titleWrapper} display="flex" justifyContent="center">
                    <Typography variant="h6" component="h2">
                        {participant.lastName ? `${participant.firstName} ${participant.lastName}` : `${participant.firstName}`}
                        <span style={{ color: "black" }}>,&nbsp;Which Role Best Describes You?</span>
                    </Typography>
                </Box>
            </Box>
        )
        roleDetailOutput = (
            <>
                <Box display="flex" flexWrap="wrap" justifyContent="center">
                    <FormControl component="fieldset">
                        <RadioGroup
                            aria-label="role"
                            name="role"
                            value={checkedRoleId}
                            onChange={handleRoleChange}
                            className={classes.radioGroup}
                        >
                            {roles.map((role) => {
                                let rolePrefix
                                if (role.roleName) {
                                    if (
                                        role.roleName.substr(0, 1).toLowerCase() === "a" ||
                                        role.roleName.substr(0, 1).toLowerCase() === "e" ||
                                        role.roleName.substr(0, 1).toLowerCase() === "i" ||
                                        role.roleName.substr(0, 1).toLowerCase() === "o" ||
                                        role.roleName.substr(0, 1).toLowerCase() === "u"
                                    ) {
                                        rolePrefix = "AN"
                                    } else rolePrefix = "A"
                                } else {
                                    rolePrefix = "A"
                                }
                                const path = `assets/images/role-select-images/role-${role.roleName.toLowerCase()}`
                                return (
                                    <FormControlLabel
                                        className={clsx(classes.radioLabel)}
                                        value={role.roleId}
                                        control={<Radio />}
                                        key={role.roleId}
                                        // eslint-disable-next-line react/jsx-no-duplicate-props
                                        label={
                                            <Box className={classes.roleContainer} key={role.roleId}>
                                                <Box>
                                                    <Box>
                                                        <Box className={classes.roleImageWrapper}>
                                                            <DynamicImage
                                                                path={path}
                                                                extension="png"
                                                                className={classes.iconImage}
                                                                alt="role-icon"
                                                            />
                                                        </Box>
                                                        <Box className={classes.roleName}>
                                                            I AM {rolePrefix} {role.roleName}
                                                        </Box>
                                                        <Divider />
                                                        <Box>
                                                            <Box className={classes.roleDescriptionWrapper}>
                                                                <Box dangerouslySetInnerHTML={{ __html: role.roleDescription }} />
                                                            </Box>
                                                        </Box>
                                                        <Box className={classes.selectButton}>
                                                            <Button
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={() => handleRoleButtonClick(role.roleId)}
                                                            >
                                                                Select
                                                            </Button>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        }
                                    />
                                )
                            })}
                        </RadioGroup>
                    </FormControl>
                </Box>
                {!participant.projectManager ? (
                    <Box>
                        <Button
                            className={clsx({ [classes.activeNone]: participant.roleId === 0 })}
                            variant="contained"
                            color="primary"
                            onClick={noneButtonOnClick}
                        >
                            None of the Above
                        </Button>
                    </Box>
                ) : null}
            </>
        )
    }

    return (
        <Box my={6} className={classes.roleWrapper}>
            <>
                {roleLoading.loading ? (
                    <Box>
                        <Typography>Loading Roles... </Typography>
                    </Box>
                ) : (
                    <>
                        <Box>{titleOutput}</Box>
                        <Box className={classes.roleDetailWrapper}>{roleDetailOutput}</Box>
                    </>
                )}
            </>
        </Box>
    )
}

export default Role
